type ButtonProps = {
  isDisabled?: boolean;
  type?: 'primary' | 'secondary';
  label?: string;
  size?: 'small' | 'medium' | 'large';
  isFluid?: boolean;
  className?: string;
  onClick?: () => void;
};

export const Button: React.FC<ButtonProps> = ({
  isDisabled = false,
  type = 'primary',
  label = 'Missing label',
  size = 'medium',
  isFluid = false,
  className,
  onClick,
}) => {
  return (
    <div className={className} onClick={() => !isDisabled && onClick && onClick()}>
      <div
        className={`flex w-full items-center justify-center rounded-md font-sans leading-8 ${
          size === 'small' ? 'text-[1.2rem]' : size === 'medium' ? 'text-[1.6rem]' : 'text-[1.8rem]'
        } font-light ${
          isDisabled && type === 'primary'
            ? 'cursor-default bg-primaryButtonBgColorDisabled text-primaryButtonColorDisabled opacity-70'
            : isDisabled && type === 'secondary'
            ? 'cursor-default bg-secondaryButtonBgColorDisabled text-secondaryButtonColorDisabled opacity-70'
            : 'cursor-pointer'
        } ${
          !isDisabled && type === 'primary'
            ? 'bg-primaryButtonColor text-primaryButtonTextColor transition-all duration-200 ease-out hover:bg-primaryButtonColorHover hover:text-primaryButtonTextColorHover'
            : !isDisabled && type === 'secondary'
            ? ' bg-secondaryButtonColor text-secondaryButtonTextColor transition-all duration-200 ease-out hover:bg-secondaryButtonColorHover hover:text-secondaryButtonTextColorHover'
            : ''
        } ${size === 'small' ? 'px-4 py-1' : size === 'medium' ? 'px-4 py-3' : 'px-4 py-6'}`}
      >
        <span className="capitalize-first">{label}</span>
      </div>
    </div>
  );
};

export default Button;
